import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Panel from '../../components/common/Panel';
import Wall from '../../components/common/Wall';
import PageLayout from '../../components/common/PageLayout';
import { setDropshipOrdersLastDayFilter } from '../../store/actions/pageFilters';
import {
  getDropshipOrders,
  dropshipOrdersReport,
  dropshipOrdersReportClose,
  setDropshipOrdersLoading,
} from '../../store/actions/dropshipOrders';
import CountTopFilter from '../../components/common/CountTopFilter';
import DropshipOrdersContainer from '../blocks/DropshipOrdersContainer';
import ActionButton from '../../components/common/ActionButton';
import DownloadReportModal from '../../components/modals/DownloadReportModal';
import Hero from '../../components/common/Hero';
import DateRange from '../../components/common/DateRange/DateRange';

function DropshipOrdersPageContainer(props) {
  const {
    activeCount,
    count,
    pendingCount,
    completedCount,
    canceledCount,
    getOrders,
    downloadReport,
    isReport,
    closeReport,
  } = props;

  const handleChangeRange = (startDate, endDate) => {
    props.setDropshipOrdersLoading(true);
    props.setOrderLastDayFilter(startDate, endDate);
  };

  const pageHero = (
    <>
      <Hero title="Drop Ship Orders" />

      <Panel fix>
        <Wall />
        <DateRange onChange={(startDate, endDate) => handleChangeRange(startDate, endDate)} />
        <Wall />
        <CountTopFilter onClick={(title) => getOrders(title)} title="ALL" count={count} activeCount={activeCount} />
        <CountTopFilter
          onClick={(title) => getOrders(title)}
          title="PROCESSING"
          count={pendingCount}
          activeCount={activeCount}
        />
        <CountTopFilter
          onClick={(title) => getOrders(title)}
          title="COMPLETED"
          count={completedCount}
          activeCount={activeCount}
        />
        <CountTopFilter
          onClick={(title) => getOrders(title)}
          title="CANCELED"
          count={canceledCount}
          activeCount={activeCount}
        />
        <Wall />
        <ActionButton type="download" size={25} onClick={downloadReport} />
        <Wall />
      </Panel>
    </>
  );

  return (
    <PageLayout top={pageHero}>
      <DownloadReportModal open={isReport} onClose={closeReport} />

      <DropshipOrdersContainer />
    </PageLayout>
  );
}

const mapStateToProps = (state) => {
  const { count, pendingCount, completedCount, canceledCount, activeCount, isReport } = state.dropshipOrders;

  return {
    count,
    pendingCount,
    completedCount,
    canceledCount,
    activeCount,
    isReport,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getOrders: (title) => dispatch(getDropshipOrders(title)),
  setDropshipOrdersLoading: (value) => dispatch(setDropshipOrdersLoading(value)),
  setOrderLastDayFilter: (startDate, endDate) => dispatch(setDropshipOrdersLastDayFilter(startDate, endDate)),
  downloadReport: () => dispatch(dropshipOrdersReport()),
  closeReport: () => dispatch(dropshipOrdersReportClose()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DropshipOrdersPageContainer);

DropshipOrdersPageContainer.propTypes = {
  count: PropTypes.number.isRequired,
  pendingCount: PropTypes.number.isRequired,
  completedCount: PropTypes.number.isRequired,
  canceledCount: PropTypes.number.isRequired,
  setOrderLastDayFilter: PropTypes.func.isRequired,
  activeCount: PropTypes.string.isRequired,
  getOrders: PropTypes.func.isRequired,
  downloadReport: PropTypes.func.isRequired,
  isReport: PropTypes.bool.isRequired,
  closeReport: PropTypes.func.isRequired,
};
